var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "translate(-0.053 -0.053)",
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.053 0.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M.053.053v122h122V.053ZM114.39,114.39H7.754V7.716H114.39Z",
    transform: "translate(-0.053 -0.053)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d",
    transform: "translate(23.008 7.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M6.037,43.084c0,30.941,38.018,65.475,38.018,65.475S82.126,73.976,82.126,43.035c0-22.6-17.029-40.922-38.037-40.922S6.048,20.431,6.048,43.031Z",
    transform: "translate(-6.037 -2.113)",
    fill: "none",
    stroke: "#832729",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 15.226,
    cy: 15.226,
    r: 15.226,
    transform: "translate(22.822 18.849)",
    fill: "none",
    stroke: "#832729",
    strokeMiterlimit: 10,
    strokeWidth: 9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogation);
export default __webpack_public_path__ + "static/media/Logation.145822fb30cb88dfc1f5cdc988eca9dd.svg";
export { ForwardRef as ReactComponent };